import React, { useState, useEffect } from 'react';
import { FaTimes, FaStar } from 'react-icons/fa';
import './SmartAppBanner.css';

const DISMISS_KEY = 'tocxi_app_banner_dismissed';
const DISMISS_DAYS = 7; // Show again after 7 days

function SmartAppBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Only show on mobile browsers
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (!isMobile) return;

    // Check if user dismissed recently
    const dismissed = localStorage.getItem(DISMISS_KEY);
    if (dismissed) {
      const dismissedAt = new Date(dismissed);
      const daysSince = (Date.now() - dismissedAt.getTime()) / (1000 * 60 * 60 * 24);
      if (daysSince < DISMISS_DAYS) return;
    }

    // Show after a short delay (don't interrupt page load)
    const timer = setTimeout(() => setVisible(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    localStorage.setItem(DISMISS_KEY, new Date().toISOString());
  };

  const handleOpen = () => {
    const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    const isAndroid = /Android/i.test(navigator.userAgent);
    if (isIOS) {
      window.location.href = 'https://apps.apple.com/in/app/tocxi/id6757497988';
    } else if (isAndroid) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.tocxi.app';
    }
  };

  if (!visible) return null;

  return (
    <div className="sab">
      <button className="sab-close" onClick={handleDismiss} aria-label="Dismiss">
        <FaTimes />
      </button>
      <img src="/icons/icon.png" alt="Tocxi" className="sab-icon" />
      <div className="sab-info">
        <span className="sab-name">Tocxi</span>
        <span className="sab-meta">
          <FaStar className="sab-star" />
          <FaStar className="sab-star" />
          <FaStar className="sab-star" />
          <FaStar className="sab-star" />
          <FaStar className="sab-star-half" />
          FREE
        </span>
      </div>
      <button className="sab-open" onClick={handleOpen}>
        OPEN
      </button>
    </div>
  );
}

export default SmartAppBanner;
